const NO_RESPONSE_PLACEHOLDER = '_No response_'

/**
 * Removes default placeholders and HTML comments (invisible boilerplate).
 * Use only for light-weight normalization for duplicate check length threshold calculation.
 */
export function normalizeForDuplicateThreshold(body: string): string {
  return body
    .replace(/<!--[\s\S]*?-->/g, '')
    .replaceAll(NO_RESPONSE_PLACEHOLDER, '')
    .trim()
}
